import { Path, Svg } from './styles';
import { IconProps } from './types';

const path = [
  'M2.15234 7.77083C2.15234 4.55083 4.76568 1.9375 7.98568 1.9375C11.2057',
  '1.9375 13.819 4.55083 13.819 7.77083C13.819 10.9908 11.2057 13.6042',
  '7.98568 13.6042C4.76568 13.6042 2.15234 10.9908 2.15234 7.77083ZM7.98568',
  '12.4375C10.5582 12.4375 12.6523 10.3433 12.6523 7.77083C12.6523 5.19833',
  '10.5582 3.10417 7.98568 3.10417C5.41318 3.10417 3.31901 5.19833 3.31901',
  '7.77083C3.31901 9.24087 4.00285 10.5547 5.06901 11.4108V12.4375H7.98568Z',
].join(' ');

const IconChat = ({ width = 15, height = 15, color, className, style }: IconProps) => (
  <Svg className={className} style={style} width={width} height={height} viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
    <Path fillRule="evenodd" clipRule="evenodd" d={path} fill={color || 'currentColor'} />
    <Path d="M4.74089 11.5827H3.57422V13.3327H7.65755V12.166H4.74089V11.5827Z" fill={color || 'currentColor'} />
    <Path d="M6.19922 8.08268H5.03255V6.91602H6.19922V8.08268Z" fill={color || 'currentColor'} />
    <Path d="M8.24089 8.08268H7.07422V6.91602H8.24089V8.08268Z" fill={color || 'currentColor'} />
    <Path d="M10.2826 8.08268H9.11589V6.91602H10.2826V8.08268Z" fill={color || 'currentColor'} />
  </Svg>
);

export default IconChat;
